import { useMutation } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useRegisterMutation() {
  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.authRegisterCreate>[0]) => SSF.api.authRegisterCreate(variables),
  });
}

export function useVerifyEmailMutation() {
  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.authEmailVerifyCreate>[0]) =>
      SSF.api.authEmailVerifyCreate(variables),
  });
}
